import { Component, Inject } from '@angular/core';
import Env from '@ridango/core/env';

@Component({
    templateUrl: './signup-complete-page.component.html'
})
export class SignupCompletePageComponent {
    constructor(@Inject('ENV') public env: Env) {}
}
